export default function Icon({
  src,
  className,
  alt,
  onClick,
}: {
  src?: string;
  className?: string;
  alt?: string;
  onClick?: () => void;
}) {
  return (
    <img
      onClick={onClick}
      className={className}
      src={src}
      alt={alt ?? ""}
      loading={"eager"}
    />
  );
}
